[
    "corepatterns/importdatatemplates/importfile",
    "corepatterns/contacts/contactpersonaldatareport",
    "corepatterns/schemabusinessrules/configurebusinessrulesoperation",
    "assetmanagementcore/assetsexplorers/assetsexplorer",
    "maintenance/preventivemaintfileimports/importpreventivemaintenances",
    "reporting/templates/edittemplate",
    "reporting/customreports/editcustomreport"
]
